import { removeDuplicates } from '../../utils'
import { markingMovement } from '../../utils/marking'
import { 
  MARKING_TOGGLE_LOADING,
  MARKING_TOGGLE_ERROR,
  MARKING_UPDATE_FIELDS,
  MARKING_BULK_UPDATE_FIELDS,
  MARKING_UPDATE_STUDENTS,
  MARKING_UPDATE_EVIDENCE_OF_LEARNING,
  MARKING_TOGGLE_MODE
} from '../actions/markingActions'

const initState = {
  loading: false,
  temp: {},
  current: {},
  student: {},
  evidenceOfLearning: {},
  currentEvidenceOfLearning: {},
  error: {},
  mode: [],
  growthGoals: [],
  studentsTemp: [],
  bulk: {
    loading: false,
    alert: {},
    students: [],
    temp: [],
    current: {},
  }
}

const markingReducer = (state = initState, action) => {
  const newState = { ...state }
  const { payload } = action

  switch (action.type) {
    case MARKING_TOGGLE_LOADING:
      newState.loading = action.loading
    break    
    case MARKING_TOGGLE_ERROR:
      newState.error = action.error
    break    
    case MARKING_UPDATE_FIELDS:
      newState[payload.name] = payload.value
    break
    case MARKING_BULK_UPDATE_FIELDS:
      newState.bulk[payload.name] = payload.value
    break

    case MARKING_UPDATE_STUDENTS: 
      let temp = newState.studentsTemp
      if (payload.method) {
        if (payload.method === 'PUT') {
          temp = temp.map((item) => {
            if (String(payload.data._id) === String(item._id)) {
              return payload.data
            } else {
              return item
            }
          })
        } else if (payload.method === 'BULK') {
          temp = temp.map((item) => {
            const find = payload.data.find((d) => String(d._id) === String(item._id))
            if (find) {
              return find
            } else {
              return item
            }
          })
        }
      } else {
        temp = payload.data
      }
      newState.studentsTemp = temp
    break    
    case MARKING_UPDATE_EVIDENCE_OF_LEARNING:
      let evidenceOfLearning =  newState.evidenceOfLearning

      if (newState.evidenceOfLearning.lcs && newState.evidenceOfLearning.lcs.length > 0) {
        const allLCs = [...newState.evidenceOfLearning.lcs, ...payload.data.lcs] 
        let lcs = allLCs.map((lc) => {
          const find = payload.data.lcs.find((x) => x._id === lc._id)
          if (find) {
            return find
          } else {
            return lc
          }
        })
        lcs = removeDuplicates(lcs)
        evidenceOfLearning = { ...newState.evidenceOfLearning, lcs}
      } else {
        evidenceOfLearning = payload.data
      }

      newState.evidenceOfLearning = evidenceOfLearning
    break
    case MARKING_TOGGLE_MODE:
      if (payload.data && payload?.data?._id) {
        const ids = newState.mode.map((x) => x._id)
        if(markingMovement.EXCLUDE === payload.data.movement) {
          delete payload.data.movement
          newState.mode = [payload.data]
        } else if (!ids.includes(payload.data._id)) {
          newState.mode = [payload.data, ...newState.mode] 
        } else {
          newState.mode = newState.mode.filter((x) => x._id !== payload.data._id)
          newState.mode = [payload.data, ...newState.mode] 
        }
        newState.mode = newState.mode.filter((x) => x.status !== 'no change')
      } else {
        newState.mode = []  
      }
    break
    default:
      break
  }

  return newState
}

export default markingReducer
